module.exports = __webpack_public_path__ + "img/logo_footer.cfc1106f.svg";